import React, { useState, useEffect } from 'react';
import ContenidoEnriquecido from '../../../../components/ContenidoEnriquecido';
import EditableField from '../../../../components/EditableFields';
import { useDetalleSolicitudModel } from '../../../../modelos/Solicitudes/modeloSolicitud';
import AnalisisIA from './AnalisisIASolicitud';

/**
 * Componente para mostrar el contenido de las pestañas de una solicitud
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.solicitud - La solicitud a mostrar
 * @param {Object} props.servicioInfo - Información específica del tipo de servicio
 * @param {String} props.initialTab - Pestaña inicial a mostrar (por defecto: 'descripcion')
 * @returns {JSX.Element} - El elemento JSX del contenido en pestañas
 */
const DescripcionActividadSolicitud = ({ solicitud, isAdmin = false, onUpdateSolicitud}) => {
    const [formContenidoEnriquecido, setFormData] = useState(solicitud.contenidoEnriquecido);
    const {actualizarContenidoEnriquecido} = useDetalleSolicitudModel();

    // 2. ✅ SE AGREGA ESTE useEffect PARA SINCRONIZAR LOS DATOS
    useEffect(() => {
      console.log("solciitud enriquecido a actualizar");
        setFormData(solicitud.contenidoEnriquecido);
    }, [solicitud.contenidoEnriquecido]); // La lista de dependencias es la clave.

    if (!solicitud) {
        return <div className="p-4 text-gray-500">No hay información disponible.</div>;
    }

    // getServicioInfo - Función mejorada
    const getServicioInfo = () => {
      const servicioLower = (solicitud.Servicio || '').toLowerCase();
      const objetoFaltante = solicitud.objetoFaltante || {};

      switch (servicioLower){
        case 'taller': return {
          info: (
            <>

            <EditableField
              field="resumen"
              label="Resumen"
              value={solicitud.resumen || 'No definido'}
              type="text"
              isAdmin={isAdmin}
              onSave={onUpdateSolicitud}
            />

            <EditableField
              field="objetoFaltante.formatoEntrega"
              label="Formato de entrega"
              value={objetoFaltante.formatoEntrega || 'Formato de entrega no definido'}
              type="text"
              isAdmin={isAdmin}
              onSave={onUpdateSolicitud}
            />

          </>
          )
        };
  
        case 'tesis': return {
          info: (
            <>
            <EditableField
              field="objetoFaltante.temaTesis"
              label="Tema de tesis"
              value={objetoFaltante.temaTesis || 'Tema de tesis no indicado'}
              type="text"
              isAdmin={isAdmin}
              onSave={onUpdateSolicitud}
            />

            <EditableField
              field="objetoFaltante.carrera"
              label="Carrera"
              value={objetoFaltante.carrera || 'Carrera no indicada'}
              type="text"
              isAdmin={isAdmin}
              onSave={onUpdateSolicitud}
            />

            <EditableField
              field="objetoFaltante.universidad"
              label="Universidad"
              value={objetoFaltante.universidad || 'Universidad no indicada'}
              type="text"
              isAdmin={isAdmin}
              onSave={onUpdateSolicitud}
            />

            <EditableField
              field="objetoFaltante.cantidadPaginas"
              label="Cantidad de Paginas"
              value={objetoFaltante.cantidadPaginas || 'Cantidad de paginas no definida'}
              type="text"
              isAdmin={isAdmin}
              onSave={onUpdateSolicitud}
            />

            <EditableField
              field="objetoFaltante.normasCitacion"
              label="Normas de citacion"
              value={objetoFaltante.normasCitacion || 'Normas de citacion no definidas'}
              type="text"
              isAdmin={isAdmin}
              onSave={onUpdateSolicitud}
            />

            </>
          )
        };
  
        case 'parcial':
        case 'quiz': {
          const isQuiz = servicioLower === 'quiz';
          return {
            info: (
              <>

              <EditableField
                field="objetoFaltante.temasExamen"
                label="Temas de examen"
                value={objetoFaltante.temasExamen || 'Temas de examen no definidas'}
                type="text"
                isAdmin={isAdmin}
                onSave={onUpdateSolicitud}
              />

              <EditableField
                field="objetoFaltante.duracionExamen"
                label="Duracion del examen"
                value={objetoFaltante.duracionExamen || 'Duracion de examen no definido'}
                type="text"
                isAdmin={isAdmin}
                onSave={onUpdateSolicitud}
              />

            
            </>
            )
          };
        }
        
        case 'clases personalizadas': return {
          info: (
            <>

            <EditableField
              field="resumen"
              label="Temas de Asesoria"
              value={solicitud.resumen || 'Temas de asesoria no definidos'}
              type="text"
              isAdmin={isAdmin}
              onSave={onUpdateSolicitud}
            />

            <EditableField
              field="objetoFaltante.numeroHoras"
              label="Numeros de horas"
              value={objetoFaltante.numeroHoras || 'Numero de horas no definidas'}
              type="text"
              isAdmin={isAdmin}
              onSave={onUpdateSolicitud}
              />

            </>
          )
        };
        
        default: return {
          info: null
        };
      }
    }
  
    const servicioInfo = getServicioInfo();

    const onSave = async(nuevoContenido) =>{
      //guardar en backend operacion de actualizacion
      await actualizarContenidoEnriquecido(solicitud.id,solicitud.nombreEmpresa,nuevoContenido);

    };

  return (
     <div>
      <h3 className="font-semibold text-gray-700 mb-2">Descripción Actividad</h3>

        {/* Contenido adicional específico por tipo de servicio */}
        {servicioInfo?.info} 

        {/* Contenido generado por IA */}
        <AnalisisIA
          explicacion={solicitud.generateExplicacionIa}
        />

        {/* Mostrar el contenido enriquecido */}
        <div className="mb-6">
          <ContenidoEnriquecido 
            contenido={formContenidoEnriquecido} 
            isAdmin={isAdmin}
            editable={true}
            onSave={onSave}
            //onChange={onChange}
          />
        </div>

    </div>
  );
};

export default DescripcionActividadSolicitud;